module.exports = __webpack_public_path__ + "static/media/9-3.aa5518ed.mp3";